import moment from "moment";
import type { ApiResponse } from "../models/ApiResponse";
import type { ProcessResponse } from "../models/ProcessResponse";
import type { UserInfo } from "../models/UserInfo";
import { getAxios } from "../helpers/api";
// import { AuthService } from "./AuthService";
import { config } from '../environments/environment'
import { number } from "yup";

class _YieldService {
    private localStorageKeys = {
        currentUser: "CURRENT_USER"
    }
    private baseUrl = config.url.STOCK_API_URL;

    async GetAllYields(): Promise<any> {
        try {
            const res = await getAxios(this.baseUrl).get("/Yield/get/all/yields");
            var response = res.data as ApiResponse<any[]>;
            if (response.isSuccessful) {
                // if (response.data.dateOfBirth) response.data.dateOfBirth = moment(response.data.dateOfBirth).format('yyyy-MM-DD');

                return this.sortData(response.data);

            }
            return [];
        } catch (error) {

            return null;
        }
    }

    async GetYieldRanges(): Promise<any> {
        try {
            const res = await getAxios(this.baseUrl).get("/Yield/get/ranges");
            var response = res.data as ApiResponse<any[]>;
            if (response.isSuccessful) {
                // if (response.data.dateOfBirth) response.data.dateOfBirth = moment(response.data.dateOfBirth).format('yyyy-MM-DD');

                return this.sortData(response.data);

            }
            return [];
        } catch (error) {

            return null;
        }
    }





    async CreateTreeFell(
        teamId: number,
        description: string,
        clerkId: string,
        supervisorId: number,
        managerId: number,
        totalQuantity: number,
        treeFellItems: any
    ): Promise<ProcessResponse> {
        try {

            const res = await getAxios(this.baseUrl).post("/Log/add/treefell", { teamId, description, clerkId, supervisorId, managerId, totalQuantity, treeFellItems });

            const data = res.data as ApiResponse<any>;
            if (data.isSuccessful) return { Successful: true, message: data.message };

            return { Successful: false, message: data.message ?? "Unable to Create Tree Fell Log. Please try again" }
        } catch (error) {

            return { Successful: false, message: "An error occurred. Please try again later" };
        }
    }



    async UploadYield(image: any,compactmentId:any,concessionId:any,description:any,rangeId:any) {
        let data = new FormData();
        // data.append(`${docName}`, image);
        data.append('file', image);
        data.append('compactmentid', compactmentId);
        data.append('concessionid', concessionId);
        data.append('description', description);
        data.append('rangeid', rangeId);

        try {
            const res = await getAxios(this.baseUrl).post("/Yield/upload/yield", data, { headers: { 'Content-Type': 'multipart/form-data' } });
            return res.data as ApiResponse<any>;
        } catch (error) {

            return null;
        }
    }

    async GetRanges(): Promise<any> {
        try {
            const res = await getAxios(this.baseUrl).get("/Yield/get/ranges");
            var response = res.data as ApiResponse<UserInfo[]>;
            if (response.isSuccessful) {
                // if (response.data.dateOfBirth) response.data.dateOfBirth = moment(response.data.dateOfBirth).format('yyyy-MM-DD');

                return this.sortData(response.data);

            }
            return [];
        } catch (error) {

            return null;
        }
    }
    async GetYieldDetail(id: number): Promise<UserInfo | any> {
        try {
            const res = await getAxios(this.baseUrl).get(`/Yield/get/yield/by/code/${id}`);
            var response = res.data as ApiResponse<any>;
            if (response.isSuccessful) {
                if (response.data.dateCreated) response.data.dateCreated = moment(response.data.dateCreated).format('yyyy-MM-DD');
                return response.data;

            }
            return [];
        } catch (error) {
            return null;
        }
    }

    async RemoveItem(yieldItemId:number): Promise<any> {
        try {

            const res = await getAxios(this.baseUrl).post("/Yield/remove/yield/item", { yieldItemId });

            const data = res.data as ApiResponse<any>;
            if (data.isSuccessful) return { Successful: true, message: data.message };

            return { Successful: false, message: data.message ?? "Unable to Remove Item. Please try again" }
        } catch (error) {

            return { Successful: false, message: "An error occurred. Please try again later" };
        }
    }

    async RemoveStampage(yieldId:number): Promise<any> {
        try {

            const res = await getAxios(this.baseUrl).post("/Yield/remove/yield", { yieldId });

            const data = res.data as ApiResponse<any>;
            if (data.isSuccessful) return { Successful: true, message: data.message };

            return { Successful: false, message: data.message ?? "Unable to Remove Item. Please try again" }
        } catch (error) {

            return { Successful: false, message: "An error occurred. Please try again later" };
        }
    }
    sortData(data:any[]) {
        let sortedData;
        sortedData = [...data].sort((a, b) => {
            return b.dateCreated.localeCompare(a.dateCreated);
        });
        return sortedData;
    }


}

export const YieldService = new _YieldService();
